import React from 'react'
import PropTypes from 'prop-types'

const DOT_CLASS = 'tw:inline-block tw:size-2.5 tw:rounded-xs!'
const FALLBACK_COLOR = '#d1d5db'

// Colored pastille (+ optional label) from a hex color; dynamic so rendered inline.
const StatusDot = ({ color, label, className }) => (
  <span className={`tw:inline-flex tw:items-center tw:gap-2 ${className}`}>
    <span aria-hidden="true" className={DOT_CLASS} style={{ backgroundColor: color || FALLBACK_COLOR }} />
    {label ? <span>{label}</span> : null}
  </span>
)

StatusDot.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  label: PropTypes.node
}

StatusDot.defaultProps = {
  className: '',
  color: null,
  label: null
}

export default StatusDot
